import React from 'react';
import { MenuItem } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import configSiteUrls from '../../configs/configSiteUrls';

type NavLinkMenuItemProps = {
  link?: string | null;
  noticiaId?: string | null;
  children: React.ReactNode;
  [key: string]: any; // permite passar props extras como onClick, sx, etc.
};

/** Detecta link externo */
const isExternal = (url?: string | null) =>
  !!url && (/^https?:\/\//.test(url) || url.includes('www'));

export function NavLinkMenuItem({ link, noticiaId, children, ...props }: NavLinkMenuItemProps) {
  // Sempre interno se tiver noticiaId
  if (noticiaId) {
    const to = `${configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW_LK}${noticiaId}`;
    return (
      <MenuItem component={RouterLink} to={to} {...props}>
        {children}
      </MenuItem>
    );
  }

  // Link externo
  if (link && isExternal(link)) {
    return (
      <MenuItem component="a" href={link} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </MenuItem>
    );
  }

  // Link interno normal
  if (link) {
    return (
      <MenuItem component={RouterLink} to={link} {...props}>
        {children}
      </MenuItem>
    );
  }

  // Fallback (não há link nem noticia)
  return <MenuItem {...props}>{children}</MenuItem>;
}
